export const formatValuesToServerData = (values) => ({
  lock_timezone_enabled: values.lockTimezoneStatus === 'locked',
  lock_timezone_content: values.lockTimezoneStatus === 'locked' && values.lockTimezoneContent
    ? values.lockTimezoneContent
    : undefined
})
